import React from 'react';
import './App.css';
import InsuranceComparison from './components/InsuranceComparison';
import './styles/InsuranceComparison.css';

function App() {
    return (
        <div className="App">
            <header className="App-header">
                <h1>Forsikrings AI Sammenligning</h1>
            </header>
            <main>
                <InsuranceComparison />
            </main>
        </div>
    );
}

export default App;
